"use client"

import React from 'react';

function SecurinTable({ data, blok }) {


    return (
        <div className=' bg-asmPageTopBG bg-no-repeat pt-16 bg-cover'>
        <div className="relative w-full max-w-[1300px] rounded-[55px] mx-auto  shadow-lg ">
            <div className="p-1 min-h-screen w-full flex justify-center items-center">
                <div className="w-full bg-white shadow-2xl rounded-[55px] overflow-hidden shadow-purple-300">
                    {/* Title with Gradient */}
                    <div className="flex justify-center items-center h-[168px] bg-gradient-to-r from-[#5A27E7] to-[#9A509D] !text-white font-aileron text-[24px] sm:text-[28px] lg:text-[36px] text-center font-bold py-8 sm:py-12 rounded-t-[55px] px-4">
                        <h1>{data.title}</h1>
                    </div>
                    {/* Table Content */}
                    <div className="overflow-x-auto">
                        <table className="table-auto w-full border-collapse">
                            <tbody>
                                {data.content.map((item, index) => (
                                    <tr
                                        key={index}
                                        className={`${
                                            index % 2 === 0 ? 'bg-purple-50' : 'bg-white'
                                        }`}
                                    >
                                        {/* Heading */}
                                        <td
                                            className={`px-4 sm:px-6 lg:px-10 py-4 sm:py-6 lg:py-8 font-aileron text-[14px] sm:text-[16px] lg:text-[18px] font-bold w-1/3 ${
                                                index % 2 === 0 ? 'bg-[#D7CCF3]' : 'bg-[#F5F1FF]'
                                            } text-[#222222]`}
                                        >
                                            {item.heading}
                                        </td>
                                        {/* Description */}
                                        <td className="px-4 sm:px-6 lg:px-10 py-4 sm:py-6 lg:py-8 text-[#222222] text-[12px] sm:text-[14px] lg:text-[16px]">
                                            {item.description}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
}

export default SecurinTable;
